import { useTranslation } from "@outschool/localization";
import React, { useEffect, useState } from "react";

import { LearnerFormWarning } from "./LearnerFormWarning";

type LearnerNameWarningProps = {
  name: string;
};

export const LearnerNameRegex = new RegExp(
  /(^[A-Za-z]{2,})([ ]{1,})([A-Za-z]{1,})/
);

export function LearnerNameWarning({ name }: LearnerNameWarningProps) {
  const { t } = useTranslation(
    "client\\components\\learner\\LearnerNameWarning"
  );
  const [showNameWarning, setShowNameWarning] = useState(false);

  useEffect(() => {
    setShowNameWarning(LearnerNameRegex.test(name));
  }, [name]);

  if (!showNameWarning) {
    return null;
  }

  return (
    <LearnerFormWarning
      message={t(
        "To protect your learner’s privacy, enter their first name only."
      )}
    />
  );
}
